import { render } from "./FlowTriggers.vue?vue&type=template&id=bdb12b4e&scoped=true"
import script from "./FlowTriggers.vue?vue&type=script&lang=js"
export * from "./FlowTriggers.vue?vue&type=script&lang=js"

import "./FlowTriggers.vue?vue&type=style&index=0&id=bdb12b4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb12b4e"]])

export default __exports__